package com.patronat.top.ui.atoms

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.selection.selectable
import androidx.compose.material3.RadioButton
import androidx.compose.material3.RadioButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.Primary200
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.RadioButtonText
import androidx.compose.foundation.interaction.MutableInteractionSource

@Composable
fun AppRadioButton(
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    label: String? = null,
    enabled: Boolean = true
) {
    val interactionSource = remember { MutableInteractionSource() }

    Row(
        modifier = modifier
            .selectable(
                selected = selected,
                interactionSource = interactionSource,
                indication = null,
                enabled = enabled,
                role = Role.RadioButton,
                onClick = onClick
            )
            .padding(vertical = 4.dp)
    ) {

        RadioButton(
            selected = selected,
            onClick = null,
            enabled = enabled,
            colors = RadioButtonDefaults.colors(
                selectedColor = Primary600,
                unselectedColor = Primary200,
                disabledSelectedColor = MineShaft500,
                disabledUnselectedColor = MineShaft500
            )
        )

        if (label != null) {
            Spacer(modifier = Modifier.width(4.dp))
            Text(
                text = label,
                style = RadioButtonText,
                color = if (enabled) RadioButtonText.color else MineShaft500
            )
        }
    }
}